import axios from "axios";
import config from "../config";

export type Mob = {
  id: string;
  name: string;
  profile: string;
  llm_model_id: string;
};

export type Mobs = {
  mobs: Mob[];
};

export type RegisterMobInput = {
  chat_room_id: string;
  name: string;
  profile: string;
  llm_model_id: string;
};

export type RegisterMobOutput = {
  id: string;
};

export type UpdateMobInput = {
  name: string;
  profile: string;
  llm_model_id: string;
};

export type GenerateMessageOutput = {
  messages: string[];
};

// Mob API functions
export const registerMob = async (token: string, data: RegisterMobInput): Promise<RegisterMobOutput> => {
  const response = await axios.post<RegisterMobOutput>(`${config.apiUrl}/mobs`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const updateMob = async (token: string, mobId: string, data: UpdateMobInput): Promise<void> => {
  await axios.put(`${config.apiUrl}/mobs/${mobId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getMobsByChatRoomId = async (token: string, chatRoomId: string): Promise<Mobs> => {
  const response = await axios.get<Mobs>(`${config.apiUrl}/chat-rooms/${chatRoomId}/mobs`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const generateMobMessages = async (
  token: string,
  mobId: string,
  chatRoomId: string,
  generationCount: number,
): Promise<GenerateMessageOutput> => {
  const response = await axios.get<GenerateMessageOutput>(
    `${config.apiUrl}/mobs/${mobId}/chat-rooms/${chatRoomId}/messages/generate/${generationCount}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};
